export default __webpack_public_path__ + "static/realWorldImg2-9c7e69917d6ca7087570a6be35420cd1.png";